var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEducation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 13,
    viewBox: "0 0 15 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.9443 8.66618V5.99951H14.1666V8.66618H13.9443Z",
    fill: "white",
    stroke: "#3F8CFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.33323 9.05503C7.66716 9.05503 7.99267 8.98483 8.29877 8.8451C8.29897 8.845 8.29918 8.84491 8.29939 8.84482L11.7221 7.28968V9.77725C11.7221 10.2789 11.3421 10.7616 10.4848 11.1448C9.64825 11.5187 8.50025 11.7217 7.33323 11.7217C6.1662 11.7217 5.0182 11.5187 4.18163 11.1448C3.32434 10.7616 2.94434 10.2789 2.94434 9.77725V7.28923L6.3682 8.84566C6.36825 8.84569 6.36831 8.84571 6.36836 8.84574C6.36842 8.84576 6.36847 8.84579 6.36853 8.84582C6.67388 8.98484 6.9993 9.05503 7.33323 9.05503Z",
    fill: "white",
    stroke: "#3F8CFF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1017 3.56528L14.1019 3.56541C14.1414 3.58332 14.1667 3.62218 14.1667 3.66621C14.1667 3.71024 14.1414 3.7491 14.1019 3.767L14.1017 3.76714L7.37943 6.82269L7.58633 7.27787L7.37943 6.82269C7.36397 6.82972 7.34838 6.83288 7.33333 6.83288C7.31829 6.83288 7.30269 6.82972 7.28724 6.82269L7.08033 7.27787L7.28724 6.82269L0.565013 3.76714L0.564724 3.767C0.525258 3.7491 0.5 3.71024 0.5 3.66621C0.5 3.62239 0.525014 3.58366 0.564857 3.56563L0.565624 3.56528L7.28706 0.51008C7.28715 0.510042 7.28723 0.510004 7.28731 0.509966C7.31687 0.496677 7.35041 0.496678 7.37997 0.509968C7.38005 0.510006 7.38013 0.510043 7.38021 0.51008L14.1017 3.56528Z",
    fill: "white",
    stroke: "#3F8CFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEducation);
export default __webpack_public_path__ + "static/media/education.a8e13246dded53ece6eaa4618fcf27ec.svg";
export { ForwardRef as ReactComponent };